<template>
  <routed-tab-layout variant="primary" />
</template>

<script setup lang="ts">
import RoutedTabLayout from '@/components/RoutedTabLayout.vue'
</script>